import React, {useEffect, useRef, useState} from "react";
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {LinearProgress} from "@mui/material";
import AudioPlayer from "../../../component/players/audioPlayer/AudioPlayer";
import {css} from "@emotion/css";
import "./UploadAudioFile.scss"
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";


export default function UploadAudioFile(
    {
        handleRefreshList
    }
) {

    const service = new FileManagerService()

    const [showUploadLoading, setShowUploadLoading] = useState(false)

    const [uploadPercent, setUploadPercent] = useState(0);
    const [audioFile, setAudioFile] = useState();

    const [audioFileName, setAudioFileName] = useState("")

    const uploadAudioFileRef = useRef();

    function uploadVideoFile({target: {files}}) {

        if (typeof files[0] !== 'undefined') {
            setAudioFile(files[0])
            setAudioFileName(files[0].name)
        }

    }

    function handleSelectVideoFile() {
        uploadAudioFileRef.current.click()
    }

    function handleHideLoading() {
        setUploadPercent(0)
    }

    function handleUploadVideo() {
        setShowUploadLoading(true)

        service.uploadVideoToServer(
            audioFile,
            setUploadPercent,
            handleHideLoading,
            FileManagerTypes.POST_AUDIOS.uploadUrl
        ).then(response => {
            setAudioFile(null)
            setAudioFileName("")
            showSuccessMessage("صوت جدید با موفقیت بارگزاری شد.")
            handleRefreshList(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setShowUploadLoading(false)
        })
    }

    useEffect(() => {
        console.log("Percent value is ", uploadPercent)
    }, [uploadPercent]);


    return (
        <div className={"baseUploadVideoFileContainer"}>
            {
                audioFile ?
                    <RaikoGridOneColumn>
                        <AudioPlayer file={audioFile} name={audioFileName}/>
                    </RaikoGridOneColumn> :
                    <RaikoAlert
                        type={raikoAlertTypes.info}
                        title={"بارگزاری صوت جدید"}
                        description={[
                            "* تنها فرمت قابل پذیرش mp3 می باشد.",
                            "",
                        ]}
                        className={css`width: 100%`}
                    />
            }

            {
                showUploadLoading ?
                    <div className={`loadingContainer ${css`width: 100%;`}`}>
                        <div className={css`
                          display: grid;
                          gap: .75rem;`
                        }>
                            <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری صوت جدید، لطفا صبور باشید...</span>
                            <LinearProgress
                                hidden={false}
                                variant="buffer"
                                value={uploadPercent}
                                valueBuffer={0}
                            />
                        </div>

                    </div> : ""
            }


            <input
                ref={uploadAudioFileRef}
                type="file"
                hidden
                accept="audio/mp3"
                onChange={uploadVideoFile}/>

            <RaikoFlexAlignEnd className={css`gap: .5rem`}>
                {
                    audioFile &&
                    <RaikoButtonSecondary
                        label={"انتخاب صوت"}
                        onClick={handleSelectVideoFile}
                    />
                }
                {
                    audioFile &&
                    <RaikoButtonPrimary
                        label={"بارگزاری صوت"}
                        onClick={handleUploadVideo}
                    />
                }
                {
                    !audioFile &&
                    <RaikoButtonPrimary
                        label={"انتخاب صوت"}
                        onClick={handleSelectVideoFile}
                    />
                }
            </RaikoFlexAlignEnd>
        </div>
    )
}
